import toast from "react-hot-toast";
import { log, supabase } from ".";
import { paisUsuariosCodigo } from "./cotizacionesGuardadas";

export const getUsuariosByPaisAndRol = async ({ pais, roles }) => {
  try {
    // `usuarios.pais` es código (CHI/PER/REG/URU); mapear si llega como nombre. Idempotente.
    const codigoPais = paisUsuariosCodigo(pais);
    if (!codigoPais) {
      log.error("getUsuariosByPaisAndRol", `País desconocido: ${JSON.stringify(pais)} — devuelvo [] controlado`);
      return [];
    }

    const data = await supabase.select("usuarios", {
      where: {
        pais: codigoPais,
        rol: { in: roles },
      },
      orderBy: { nombre: "asc" },
    });

    if (data?.length === 0) {
      toast.error("No se encontraron usuarios con esos criterios");
      throw new Error("No data found");
    }

    return data;
  } catch (error) {
    log.error("getUsuariosByPaisAndRol", error);
    throw error;
  }
};
